import { Line as KonvaLine } from "react-konva"
import { useAppSelector } from "../../../../store/hooks"
import { Transform } from "../../../../geometry/transformation"
import { hitStrokeCorrection } from "../../util/strokeCorrection"
import { useMemo } from "react"
import { RootState } from "../../../../store/store"

const BasePolygon = (({ setRef, shapeProps, onClick, interaction }: BaseShapeProps<PolygonShape>) => {
    const lineTypes = useAppSelector((state: RootState) => state.tool.lineTypes)
    const scale = useAppSelector((state: RootState) => state.interface.viewport.scale)
    // const lineRef = useRef<Konva.Line>(null);
    // const dispatch = useAppDispatch();
    const trafo = new Transform(shapeProps.transformation);

    const trafoedPoints = shapeProps.points.map(coordiante => {
        const c = trafo.point2d(coordiante);
        return { ...coordiante, x: c.x, y: c.y }
    });
    const correctedHitStrokeWidth = useMemo(() => hitStrokeCorrection(shapeProps.hitStrokeWidth, shapeProps.strokeWidth, scale), [shapeProps, scale]);
    // useEffect(() => {
    //     console.log(lineRef.current?.id());

    //     if (setRef) setRef(lineRef)
    //     const size = lineRef.current?.size();
    //     const payload = size ? { size: size, id: shapeProps.id } : undefined;
    //     // dispatch(modelUpdateBoundingbox(payload))
    // }, [lineRef, setRef])
    // console.log("cucc");


    const newProps = /* useMemo(() => {


        return  */{
        ...shapeProps,
        dash: lineTypes.find((a, i) => i === shapeProps.dashID)?.dash,
        id: `${shapeProps.id}`,
        points: trafoedPoints.flatMap(p => [p.x, -p.y]),
        draggable: shapeProps.draggable ? shapeProps.draggable : true,
        hitStrokeWidth: correctedHitStrokeWidth,
        closed: true,
    }
    /*} , [shapeProps, correctedHitStrokeWidth, lineTypes, trafoedPoints]) */


    return (
        <KonvaLine
            ref={setRef}
            key={shapeProps.id}
            dragBoundFunc={function (this, pos) {
                return this._lastPos || this.absolutePosition();
            }}
            onDragStart={interaction?.handleDragStart}
            onDragMove={interaction?.handleDragMove}
            onDragEnd={interaction?.handleDragEnd}
            onClick={onClick}
            {...newProps}
        />
        // Line
    )
})
const createPolygonBase = (shapeProps: GeometricShape) => {
    if (shapeProps.type === "polygon") {
        return <BasePolygon shapeProps={shapeProps} ></BasePolygon>
    } else {
        throw Error("not a Polygon in place of a polygon")
    }
}

export { createPolygonBase }
export default BasePolygon;